import { useGetCultureIndexForecastDatesQuery } from 'services/api/Meteorology/Agro/CultureIndex';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';

export default function useForecastDates() {
  const { data, error } = useGetCultureIndexForecastDatesQuery();

  useHandleRequestErrors(error as ResponseError);

  return {
    forecastDates: data || [],
  };
}
